import API from '@common/crud';
import Fetchable from '@util/middlewares/fetchable-middleware';

const fetchable = new Fetchable(API());

export default fetchable;
